<template>
  <div class="intro-y flex items-center mt-8"></div>
</template>
